import { render, staticRenderFns } from "./articleDetailType2.vue?vue&type=template&id=426abca4&scoped=true&"
import script from "./articleDetailType2.vue?vue&type=script&lang=ts&"
export * from "./articleDetailType2.vue?vue&type=script&lang=ts&"
import style0 from "./articleDetailType2.vue?vue&type=style&index=0&id=426abca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426abca4",
  null
  
)

export default component.exports